<div class="ir-plugin th-plugin ir-plugin-totaltimetorepair" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.total-time-to-repair.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data" >
          <div *ngFor="let message of messages"><span  innerHtml="{{ message | translate: { value: plugin } }}"></span>
      </div>  </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div *ngFor="let item of totalTimeToRepairs">
      <div class="ir-plugin-values th-plugin-values" *ngIf="item && item.Reparator != -1">
        <p>
          <span
            >{{ 'plugins.total-time-to-repair.repair-will-take' | translate }}
            <strong class="ir-ph1">{{ item?.Days | number: '1.0-1' }}</strong>
            {{ 'plugins.total-time-to-repair.days' | translate }}
            {{ 'plugins.total-time-to-repair.by' | translate }}
            {{ item?.Count | number: '1.0' }}
            <strong class="ir-ph1">{{ item?.Reparator | reparatorpipe }}</strong>
          </span>
        </p>
      </div>
    </div>
  </div>
</div>
